<template>
  <div>
    <Header :retailerId="retailerId" /> 
    <DeliveryError v-if="error" :retailerId="retailerId" :error="error" />
    <div v-else-if="isLoading" class="wrapper">
      <div class="box box--no-v-padding text text--align-center text--big-lineheight">
          <i class="fas fa-spinner fa-spin" style="font-size: 72px; line-height: 200px;"></i>
      </div>
    </div>
    <div v-else-if="isUnknown" class="wrapper">
      <h1 class="header header--margin-bottom text text--danger text--align-center text--big-lineheight">
          <i class="fas fa-exclamation-circle"></i>
          Sorry, we don't have any tracking information on this order
      </h1>
      <div class="text text--align-center">{{ error }}</div>
    </div>
    <DeliveryComplete v-else-if="isDelivered" :retailerId="retailerId" :arrivalTime="arrivalTime" />
    <div v-else class="wrapper">
      <div v-if="isFailed" class="wrapper">
        <h1 class="header header--margin-bottom text text--danger text--align-center text--big-lineheight">
            <i class="fas fa-exclamation-circle"></i>
            Sorry, we were unable to deliver your furniture today
        </h1>
        <div class="text text--align-center text--big-lineheight">
          Please call us on <a href="tel:0800 110 5000">0800 110 5000</a> to <span style="white-space:nowrap">re-arrange</span> delivery
        </div>
      </div>
      <div v-else>
        <h1 v-if="retailerId === 'SOF'" class="sof-title">Your order is on the way! See where it is below</h1>
        <h1 v-else class="header">We're on our way</h1>
        <google-map 
          v-if="!isWithoutGPS"
          v-bind="{markerCoordinates, selectLocation, vanPath}" 
        />
        <div v-else>
          <div class="tracker-widget">
            <div class="tracker-widget__bar"></div>
            <div class="tracker-widget__bullet tracker-widget__bullet--workshop">
              <span>Distribution Centre</span>
            </div>
            <div class="tracker-widget__bar tracker-widget__bar--progress" :style="{ right: `calc(${(1-progress) * 100}%)` }"></div>
            <div class="tracker-widget__bullet tracker-widget__bullet--van fa" :style="{ left: `calc(${progress * 100}% - 15px)` }"></div>
            <div class="tracker-widget__bullet tracker-widget__bullet--home">
              <span>Your Home</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isFailed" class="box-container">
        <div class="box box--border box--text-center">
          <div class="text">
            We're aiming to deliver your furniture
          </div>
          <div class="text text--big text--bold text--margin-bottom">
            between {{ startTime }} and {{ endTime }}
          </div>
          <div v-if="!isWithoutGPS" class="text text--smaller">
            We are running
            <strong v-if="isLate">
              behind schedule
            </strong>
            <strong v-else>
              on schedule
            </strong>
          </div>
          <div class="text text--smaller text--margin-bottom">
            <span v-if="isWithoutGPS">
              Unfortunately we are unable to provide tracking at present. 
              You are delivery number <strong>{{ customerIndex }}</strong> 
              of <strong>{{ allWaypoints }}</strong>.
            </span>
            <span v-else>
                making delivery number <strong>{{ currentIndex }}</strong>,
                you are delivery number <strong>{{ customerIndex }}</strong>
            </span>
          </div>
          <div class="text text--smaller" style="max-width: 275px; margin: 0 auto;">
            We will attempt to call you approximately 1 hour before to confirm your delivery
          </div>
        </div>
        <div class="box box--border box--max-width">
          <strong>Delivery Address:</strong>
          <div class="text text--big-lineheight">
            <div>{{ postcode }}</div>
          </div>
        </div>
      </div>
      <!--<div v-if="!isFailed && isWithoutGPS" class="text text--big-lineheight text--align-center">
        <strong>Need to speak to us about your delivery?</strong>
        <div> If you have any questions or issues with this delivery, or you will no longer be home, please contact us on</div>
        <div>
          <a href="tel:0800 110 5000">0800 110 5000</a>
        </div>
      </div>-->
    </div>
    <DeliveryInstructions v-if="!isFailed && !isDelivered && !isLoading" :retailerId="retailerId" /> 
  </div>
</template>

<script>
  import { getOrderData } from './../services/api';
  import Header from './../components/Header';
  import GoogleMap from './../components/GoogleMap';
  import DeliveryComplete from './../components/DeliveryComplete';
  import DeliveryError from './../components/DeliveryError';
  import DeliveryInstructions from './../components/DeliveryInstructions';
  import moment from 'moment';

  export default {
    name: 'Tracker', 
    components: {
      Header,
      GoogleMap,
      DeliveryComplete,
      DeliveryError,
      DeliveryInstructions
    },
    head: {
       link: [
        { rel: 'icon', href: require('./../assets/img/sodelco-logo-3x.png'), sizes: '16x16', type: 'image/png' }
      ]
    },
    props: ['date', 'cdcId', 'vanId', 'orderNumber', 'retailerId'],
    data () {
      return {
        error : null,
        isUnknown : false,
        isFailed : false,
        isLoading : true,
        isDelivered: false,
        isWithoutGPS : false,
        arrivalTime: '',
        markerCoordinates: [],
        vanPath: [],
        scheduledArrival : null,
        currentDelivery : 0,
        totalDeliveries : 0,
        postcode: '',
        progress: 0,
      }
    },
    computed: {
      unknown: function(){
        return '‎...';
      },
      startTime: function(){
        return this.scheduledArrival && moment(this.scheduledArrival).add(-90,'minutes').format('HH:mm') || this.unknown
      },
      endTime: function(){
        return this.scheduledArrival && moment(this.scheduledArrival).add(90, 'minutes').format('HH:mm') || this.unknown
      },
      timeDiff: function(){
        return moment.duration( moment(this.scheduledArrival).diff( new Date()) );
      },
      hoursAway: function(){
        return parseInt(this.timeDiff.asHours());
      },
      minutesAway: function(){
        return parseInt(this.timeDiff.asMinutes()) % 60 || this.unknown;
      },
      minutesDiff : function(){
        return parseInt(this.timeDiff.asMinutes());
      },
      isLate: function(){
        return moment(new Date()).isAfter(moment(this.scheduledArrival).add(90, 'minutes').toDate()) //this.hoursAway < 0 || this.minutesAway < 0
      }
    },
    created () {
      const { orderNumber } = this.$route.params;
      getOrderData(orderNumber)
        .catch( e => {
          console.log(e);
          this.error = e.response && e.response.data && e.response.data.message || e;
        })
        .then(data => {
          if(this.error){
            this.isLoading = false;
            return;
          }
          this.isUnknown = data.trip.isUnknown;
          this.isFailed = data.trip.isFailed;
          this.isDelivered = data.trip.isDelivered;
          this.arrivalTime = data.trip.isDelivered && moment(data.trip.actualArrival).format('dddd, D MMMM')
          this.markerCoordinates = [];
          this.scheduledArrival = data.trip.scheduledArrival;
          this.customerIndex = data.trip.customerIndex;
          this.currentIndex = data.trip.currentIndex;
          this.allWaypoints = data.trip.allWaypoints;
          this.postcode = data.customer.postcode;
          this.isWithoutGPS = data.currentLocation.isWithoutGPS;
          if(this.isWithoutGPS){
            const progress = Math.max( 0.1, this.currentIndex/this.customerIndex );
            setTimeout(() => this.progress = progress, 200);
          }
          if(data.currentLocation.lat){
            this.markerCoordinates.push({
              lat: data.currentLocation.lat,
              long: data.currentLocation.long,
              id: '1',
              status: 'van'
            });
          }
          if(data.customerLocation.lat){
            this.markerCoordinates.push({
              lat: data.customerLocation.lat,
              long: data.customerLocation.long,
              id: '2',
              status: 'home'
            });
          }
          this.isLoading = false;
        });
    },
    methods: {
      selectLocation: function(id){
        console.log('select location ', id)
      }
    }
  }
</script>


